module.exports = __webpack_public_path__ + "img/mapMarker.7225645f.png";